<script>
import {ElMessage, ElMessageBox, ElNotification} from "element-plus";

export default {
  name: "SchoolBoards",
  data() {
    return {
      loading: false,
      dataList: [],
      totalElements: 0,
      totalPages: null,
      size: 15,
      page: 1,
      types: {
        VOTE: 'primary',
        MODERATE: 'warning',
        ACCEPT: 'success'
      },
      baseUrl: process.env.VUE_APP_BASE_API_URL,
      uploadHeader: {Authorization: `${this.$store.state.accessToken}`},
    }
  },
  computed: {
    currentPage() {
      return this.$route.query.page ? parseInt(this.$route.query.page, 10) : 1;
    }
  },
  methods: {
    onSuccessUpload() {
      this.loading = false;
      ElNotification.success({
        message: "Amaliyot muvaffaqiyatli bajarildi!",
      });
    },
    onErrorUpload(error) {
      if (error.status === 401) {
        this.$store.commit("signOut");
        this.$router.push({name: "Auth"});
      }
      ElNotification.error({
        message:
            JSON.parse(error?.message)?.message ||
            "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
        type: "error",
      });

      this.loading = false;
    },
    onExceed(files) {
      console.log("exceeds", files);
      // this.form.file[0] = files[0]
    },
    downloadFile(boardId) {
      this.loading = true;
      this.$http
          .get(`api/v1/my-school/boards/${boardId}/budget-info/excel`, {
            responseType: "blob",
          })
          .then((res) => {
            const url = URL.createObjectURL(
                new Blob([res.data], {
                  type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
                })
            );
            const header = res.headers.get("Content-Disposition");
            const parts = header.split(";");
            let fileName = parts[1].split("=")[1];
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          })
          .catch(({response}) => {
            ElNotification({
              title: "Ogohlantirish",
              message:
                  response.data.message ||
                  "Ma'lumot yuklashda xatolik sodir bo'ldi!",
              type: "warning",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    handleSizeChange(val) {
      this.page = 1;
      this.$router
          .replace({
            query: {...this.$route.query, size: val},
          })
          .then(() => {
            this.getSchoolBoards();
          })
          .catch(() => {
          });
    },
    handleCurrentChange(val) {
      this.$router
          .replace({
            query: {...this.$route.query, page: val},
          })
          .then(() => {
            this.getSchoolBoards();
          })
          .catch(() => {
          });
    },
    getSchoolBoards() {
      this.loading = true;
      this.page = this.$route.query.page ? this.$route.query.page : 1;
      this.size = this.$route.query.size
          ? parseInt(this.$route.query.size || "")
          : this.size;

      this.$http
          .get(`api/v1/my-school/boards`, {
            params: {
              limit: this.size,
              offset: (this.page - 1) * this.size,
            },
          })
          .then(({data}) => {
            this.dataList = data.boards;
            this.totalElements = data.count;
          })
          .catch((error) => {
            ElNotification.error({
              message:
                  error.response.data.message ||
                  "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    onClickDelete(id) {
      ElMessageBox.confirm("Ma'lumoitni o'chirasizmi?", "Diqqat!", {
        confirmButtonText: "Ha",
        cancelButtonText: "Bekor qilish",
        type: "warning",
      })
          .then(() => {
            this.loading = true;
            this.$http
                .delete(`/api/v1/my-school/boards/${id}`)
                .then(() => {
                  ElMessage({
                    type: "success",
                    message: "Muvaffaqqiyatli o'chirildi",
                  });
                  this.getSchoolBoards();
                })
                .catch(() => {
                  ElNotification({
                    type: "error",
                    title: "Xatolik",
                    message: "Iltimos, qayta urinib ko'ring",
                  });
                })
                .finally(() => {
                  this.loading = false;
                });
          })
          .catch(() => {
            ElMessage({
              type: "info",
              message: "O'chirish bekor qilindi",
            });
          });
    },
    indexMethod(index) {
      return index + (this.page - 1) * this.size + 1
    }
  },
  mounted() {
    this.getSchoolBoards();
  }
}
</script>

<template>
  <div v-loading.fullscreen="loading">
    <div class="header">
      <div class="filters">
      </div>
      <div style="display: flex;gap:5px">
        <router-link to="school-board/add" class="el-button el-button--primary">
          Qo'shish
        </router-link>
      </div>
    </div>
    <el-table
        :data="dataList"
        class="table"
        border
        height="calc(100vh - 235px)"
    >
      <el-table-column type="index" :index="indexMethod" width="80" label="#"/>
      <el-table-column prop="title" label="Nomi" min-width="280"/>
      <el-table-column prop="year" label="Yili" min-width="60"/>
      <el-table-column prop="season" label="Mavsum" min-width="90"/>
      <el-table-column prop="budget" label="Ajratilgan qiymat" min-width="180">
        <template v-slot="scope">
          {{ scope.row.budget && scope.row.budget?.toLocaleString('ru-RU') + ' UZS' }}
        </template>
      </el-table-column>
      <el-table-column prop="stage" label="Holati" min-width="120">
        <template v-slot="scope">
          <el-tag
              v-if="scope.row.stage"
              :type="types[scope.row.stage]||'info'"
              effect="dark"
              round
          >
            {{ scope.row.stage }}
          </el-tag>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="initiatives_count" label="Tashabbus soni" min-width="140"/>
      <el-table-column prop="initiatives_max_amount" label="Tashabbus qiymati" min-width="140">
        <template v-slot="scope">
          {{ scope.row.initiatives_max_amount?.toLocaleString('ru-RU') + ' UZS' }}
        </template>
      </el-table-column>
      <el-table-column prop="accepting_start" label="Qabul boshlanishi" min-width="175">
        <template v-slot="scope">
          {{ $moment(scope.row.accepting_start).format('DD.MM.YYYY | HH:mm:ss') }}
        </template>
      </el-table-column>
      <el-table-column prop="accepting_end" label="Qabul tugashi" min-width="175">
        <template v-slot="scope">
          {{ $moment(scope.row.accepting_end).format('DD.MM.YYYY | HH:mm:ss') }}
        </template>
      </el-table-column>
      <el-table-column prop="moderating_start" label="Moderatsiya boshlanishi" min-width="175">
        <template v-slot="scope">
          {{ $moment(scope.row.moderating_start).format('DD.MM.YYYY | HH:mm:ss') }}
        </template>
      </el-table-column>
      <el-table-column prop="moderating_end" label="Moderatsiya tugashi" min-width="175">
        <template v-slot="scope">
          {{ $moment(scope.row.moderating_end).format('DD.MM.YYYY | HH:mm:ss') }}
        </template>
      </el-table-column>
      <el-table-column prop="moderating_start" label="Ovoz berish boshlanishi" min-width="175">
        <template v-slot="scope">
          {{ $moment(scope.row.voting_start).format('DD.MM.YYYY | HH:mm:ss') }}
        </template>
      </el-table-column>
      <el-table-column prop="moderating_end" label="Ovoz berish tugashi" min-width="175">
        <template v-slot="scope">
          {{ $moment(scope.row.voting_end).format('DD.MM.YYYY | HH:mm:ss') }}
        </template>
      </el-table-column>
      <el-table-column prop="rules" label="Qoidalar" min-width="140">
        <template v-slot="scope">
          <el-popover
              placement="top-start"
              title="Qoidalar"
              :width="200"
              trigger="hover"
              :content="scope.row.rules"
          >
            <template #reference>
              <span>{{ scope.row.rules.substring(0, 10) + '...' }}</span>
            </template>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="description" label="Izoh" min-width="140">
        <template v-slot="scope">
          <el-popover
              placement="top-start"
              title="Izoh"
              :width="200"
              trigger="hover"
              :content="scope.row.description"
          >
            <template #reference>
              <span>{{ scope.row.description.substring(0, 10) + '...' }}</span>
            </template>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="" width="210" align="center">
        <template #default="scope">
          <el-space>
            <el-upload
                ref="uploadRef"
                class="upload-demo"
                style="display:flex"
                :action="`${baseUrl}api/v1/my-school/boards/${scope.row.id}/budget-info/excel`"
                :headers="uploadHeader"
                :multiple="false"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                :limit="1"
                :on-exceed="onExceed"
                :on-success="onSuccessUpload"
                :on-error="onErrorUpload"
            >
              <template #trigger>
                <el-button size="small" style="width: 100%" type="warning">
                  <img
                      src="@/assets/images/upload-file.png"
                      alt=""
                      style="height: 20px"
                  />
                </el-button>
              </template>
            </el-upload>
            <el-button size="small" type="success" @click="downloadFile(scope.row.id)"
            ><img
                src="@/assets/images/excel-download.png"
                alt=""
                style="height: 20px"
            />
            </el-button>
            <el-button
                type="primary"
                size="small"
                @click="
              $router.push({
                name: 'SchoolBoardFormEdit',
                params: { id: scope.row.id },
              })
            "
            >
              <img height="15" src="@/assets/images/icons/edit.svg" alt="action"/>
            </el-button>
            <el-button
                type="danger"
                size="small"
                @click="onClickDelete(scope.row.id)"
            >
              <img height="15" src="@/assets/images/icons/delete.svg" alt="action"/>
            </el-button>
          </el-space>
        </template>
      </el-table-column>
    </el-table>
    <el-row>
      <el-col :span="24">
        <div class="pagination-wrapper">
          <span>Jami: {{ totalElements }}</span>
          <el-pagination
              v-model:current-page="currentPage"
              class="pagination"
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
              layout="sizes, prev, pager, next"
              :total="totalElements"
              v-model:page-size="size"
              :page-count="totalPages"
              :background="true"
              :page-sizes="[15, 20, 30, 50, 100, 200, 500, 1000]"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<style scoped lang="scss">
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;

  .filters {
    display: flex;
    gap: 10px;
  }
}

.el-button--primary {
  text-decoration: none;
}

.pagination-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 12px;
}

.pagination-wrapper > span {
  color: #0a194e;
  font-family: "Montserrat-Bold", sans-serif;
}
</style>
